import React, { useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import { TopBar } from '@components/topBar'
import { Footer } from '@components/footer'

type BaseLayoutProps = {
  title?: string
  footerDark?: boolean
  pageIsResponsive?: boolean
  pageIsLiquidContainer?: boolean
}

export const BaseLayout: React.FC<BaseLayoutProps> = ({
  title,
  children,
  footerDark = false,
  pageIsResponsive = false,
  pageIsLiquidContainer = false,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  )
  const pageTitle = title ? `${title} | FullCalendar` : site.siteMetadata?.title

  useEffect(() => {
    document.body.classList.toggle('responsive-enabled', pageIsResponsive)
  }, [pageIsResponsive])

  return (
    <>
      <Helmet
        title={pageTitle}
        meta={[
          { httpEquiv: 'Content-Type', content: 'text/html; charset=utf-8' },
          pageIsResponsive
            ? {
              name: 'viewport',
              content: 'width=device-width, initial-scale=1',
            }
            : {},
        ]}
        // keep this font in sync with legacy/docs/_includes/head-css.html
        link={[
          {
            rel: 'stylesheet',
            href: 'https://fonts.googleapis.com/css?family=Muli:300,400,600,800,900',
          },
        ]}
      >
        {pageIsLiquidContainer && <style>{`.container {max-width: none;}`}</style>}
      </Helmet>

      <TopBar />
      <main>{children}</main>
      <Footer dark={footerDark} />
    </>
  )
}

export default BaseLayout
